<template>
  <div class="position-relative sd-date-overview" :class="subBranch == 2 ? 'vo-school' : ''">
    <div class="dates">
      <div class="row-dates">
        <div class="align-left"><strong>Dag</strong></div>
        <div class="align-left"><strong>Datum</strong></div>
        <div class="align-left">
          <strong>Werktijden</strong>
        </div>
        <template v-if="subBranch == '2'">
          <div class="time periods">
            <strong>Lesuren</strong>
          </div>
          <div class="time declarable-hours">
            <strong>Klokuren</strong>
          </div>
        </template>
      </div>
    </div>
    <div class="dates" v-for="(item, key, index) in allDates" :key="key">
      <div v-if="index < maxVisibleDates" class="row-dates" :class="dateIsUnmatched(key) ? 'text-red' : ''">
        <div class="weekday"><strong>{{ dayOfWeek(key) }}</strong></div>
        <div class="date">{{ dateFlip(key) }}</div>
        <div class="time">
          {{ item['startTime'] }} - {{ item['endTime'] }}
        </div>
        <template v-if="subBranch == '2'">
          <div class="time periods">
            {{ item['periods'] }} lesuur
          </div>
          <div class="time declarable-hours">
            {{ item['declarable_hours'] }} uur
          </div>
        </template>
      </div>
    </div>
    <div class="dates collapse" id="collapsable-dates" v-for="(item, key, index) in allDates" :key="dateFlip(key)">
      <div v-if="index >= maxVisibleDates" class="row-dates" :class="dateIsUnmatched(key) ? 'text-red' : ''">
        <div class="weekday"><strong class="default-cursor">{{ dayOfWeek(key) }}</strong></div>
        <div class="date">{{ dateFlip(key) }}</div>
        <div class="time">
          {{ item['startTime'] }} - {{ item['endTime'] }}
        </div>
        <template v-if="subBranch == '2'">
          <div class="time periods">
            {{ item['periods'] }} lesuur
          </div>
          <div class="time declarable-hours">
            {{ item['declarable_hours'] }} uur
          </div>
        </template>
      </div>
    </div>
    <div class="mt-4 text-right" v-if="hiddenDates > 0">
      <a
          class="text-derect"
          data-toggle="collapse"
          href="#collapsable-dates"
          role="button"
          aria-expanded="false"
          aria-controls="collapsable-dates"
          @click="toggleShowAllDates"
      >
        <strong class="yellow-link" v-if="!showAllDates">+ Bekijk alle dagen</strong>
        <strong class="yellow-link" v-if="showAllDates">- Minder datums weergeven</strong>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      maxVisibleDates: 4,
      totalDates: null,
      hiddenDates: null,
      showAllDates: false
    };
  },
  mounted() {
    this.calculateDates();
  },
  props: {
    allDates: Object,
    hiredDates: Array,
    subBranch: String
  },
  methods: {
    calculateDates() {
      this.totalDates = Object.keys(this.allDates).length;
      this.hiddenDates = this.totalDates - this.maxVisibleDates;
    },
    dateIsUnmatched(date) {
      for (let i = 0; i < this.hiredDates.length; i++) {
        if (this.hiredDates[i] === date) {
          return false;
        }
      }

      return true;
    },
    dateFlip(date) {
      return date.split("-").reverse().join("-");
    },
    dayOfWeek(date) {
      const weekdays = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
      let dayAsNumber = new Date(date).getDay();
      return weekdays[dayAsNumber];
    },
    firstDate() {
      return Object.keys(this.allDates)[0];
    },
    lastDate() {
      let lastIndex = Object.keys(this.allDates).length - 1;
      return Object.keys(this.allDates)[lastIndex];
    },
    toggleShowAllDates() {
      this.showAllDates = !this.showAllDates;
    }
  }
};
</script>

<style scoped>
.text-red {
  color: #f52121;
}

.yellow-link {
  color: #FFCD00;
}

.row-dates {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  font-size: 12px;
  margin-bottom: 15px;
  line-height: 1;
}

.vo-school .row-dates {
  grid-template-columns: 50px 1fr 1fr 1fr;
}

.declarable-hours {
  display: none;
}

@media screen and (max-width: 500px) {
  .row-dates {
    grid-template-columns: 50px 1fr 1fr;
  }

  .vo-school .row-dates {
    justify-content: space-between;
    grid-template-columns: 25px 70px 75px 45px 50px;
    gap: 10px;
  }
}

@media screen and (max-width: 390px) {
  .vo-school .row-dates {
    justify-content: space-between;
    grid-template-columns: 25px 40px 60px 45px 50px;
    gap: 0;
  }
}

.row-dates .align-left {
  text-align: left;
}

.row-dates .align-center {
  text-align: center;
}

.row-dates .align-right {
  text-align: right;
}
</style>
